@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        <div
          class="mt-1"
          fxLayout="row"
          fxLayoutAlign="start center">
          <div
            style="width: 50px"
            class="body-small-500">
            {{ 'MAP.IMAGE-URL' | translate }}
          </div>
          <div style="width: 100%">
            <input
              [(ngModel)]="imageUrl"
              class="input"
              type="text"
              placeholder="{{ 'MAP.IMAGE-URL' | translate }}" />
          </div>
        </div>
        <div class="mt-4">
          <img [attr.src]="imageUrl && imageUrl !== 'null' ? imageUrl : ''" />
        </div>
      </div>
    } @else {
      @if (!!imageUrl && imageUrl !== 'null') {
        <div class="mt-4">
          <img
            class="image-display"
            [attr.src]="imageUrl" />
        </div>
      } @else {
        <div>---</div>
      }
    }
  </div>
}
